/* eslint-disable import/prefer-default-export */
import * as React from 'react'
import * as styles from '../../date.pickers.styl'

interface WeekdayLabelsProps {
  labels: string[]
}

export const WeekdayLabels: React.FC<WeekdayLabelsProps> = ({
  labels = []
}: WeekdayLabelsProps) => (
  <div className={styles.weekdayLabels} role="weekday-labels">
    {labels.map(dayLabel => (
      <div className={styles.dayLabel} key={dayLabel} role="day-label">
        {dayLabel}
      </div>
    ))}
  </div>
)
